import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mode-single-color-swatch',
  standalone: true,
  imports: [CommonModule],
  template: `<div
    style="height: 16px; width: 16px; border-radius: 4px"
    class="swatch"
    [style.background-color]="color"
  ></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleColorSwatchComponent {
  @Input({ required: true }) color!: string;
}
